import React, { useState, useEffect } from "react";
import { Modal, Button, Input, Form } from "antd";
import Permission, {
    calcularSelecionarTodosGeralCoerente,
    PERMISSION_MASTER_GROUP_KEYS,
} from "../../components/permission/index";
// import firebase from '../../config/firebase';
import perfilService from "../../service/perfil.service";
import "./createListPerfil.css";
import { useSelector } from "react-redux";

const buildPermissoes = (valor) =>
    PERMISSION_MASTER_GROUP_KEYS.reduce((acc, grupo) => {
        acc[grupo] = {
            selecionarTodos: valor,
            isView: valor,
            isCreate: valor,
            isEdit: valor,
            isDelete: valor,
        };
        return acc;
    }, {});

const emptyPermissoes = buildPermissoes(false);

/** Preset de um novo perfil: todas as permissões marcadas por padrão. */
const initialPermissoes = buildPermissoes(true);

export default function CreateListPerfil({ open, onClose, record, onSaveChange, allowedPermissions }) {

    // const db = firebase.firestore();

    const user = useSelector(state => state.user);

    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    useEffect(() => {
        if (record) {
            form.setFieldsValue({
                nomePerfil: record.nomePerfil,
            });
            const mergedPermissoes = { ...emptyPermissoes };
            Object.keys(emptyPermissoes).forEach((key) => {
                mergedPermissoes[key] = {
                    ...emptyPermissoes[key],
                    ...(record.permissoes?.[key] || {}),
                };
            });
            Object.keys(record.permissoes || {}).forEach((group) => {
                if (!mergedPermissoes[group]) {
                    mergedPermissoes[group] = {
                        selecionarTodos: false,
                        isView: false,
                        isCreate: false,
                        isEdit: false,
                        isDelete: false,
                        ...record.permissoes[group],
                    };
                }
            });
            setPermissoes(mergedPermissoes);
            setSelecionarTodosGeral(
                calcularSelecionarTodosGeralCoerente(mergedPermissoes),
            );
        }
    }, [record, form]);

    const handleOk = () => form.submit();

    const [permissoes, setPermissoes] = useState(initialPermissoes);

    const [selecionarTodosGeral, setSelecionarTodosGeral] = useState(true);

    // handler por grupo
    const handleChange = (grupo, campo) => {
        setPermissoes((prev) => {
            let novoGrupo;

            if (campo === "selecionarTodos") {
                const novoValor = !prev[grupo].selecionarTodos;
                novoGrupo = {
                    selecionarTodos: novoValor,
                    isView: novoValor,
                    isCreate: novoValor,
                    isEdit: novoValor,
                    isDelete: novoValor,
                };
            } else {
                novoGrupo = {
                    ...prev[grupo],
                    [campo]: !prev[grupo][campo],
                };

                // recalcula o "selecionarTodos" do grupo
                const todosSelecionados =
                    novoGrupo.isView &&
                    novoGrupo.isCreate &&
                    novoGrupo.isEdit &&
                    novoGrupo.isDelete;
                novoGrupo.selecionarTodos = todosSelecionados;
            }

            const novoEstado = {
                ...prev,
                [grupo]: novoGrupo,
            };

            if (grupo === "freight" && campo === "selecionarTodos") {
                if (novoGrupo.selecionarTodos === true) {
                    const grupoLigado = {
                        selecionarTodos: true, isView: true,
                        isCreate: true, isEdit: true, isDelete: true,
                    };
                    novoEstado["freightPricing"] = { ...grupoLigado };
                    novoEstado["freightDriver"] = { ...grupoLigado };
                    novoEstado["freightFreight"] = { ...grupoLigado };
                    novoEstado["freightCannotRelease"] = { ...grupoLigado };
                    novoEstado["freightCancel"] = { ...grupoLigado };
                    novoEstado["freightReopen"] = { ...grupoLigado };
                    novoEstado["freightStoppingPointLatLong"] = { ...grupoLigado };
                }
                else if (novoGrupo.selecionarTodos === false) {
                    const grupoDesligado = {
                        selecionarTodos: false, isView: false,
                        isCreate: false, isEdit: false, isDelete: false
                    };
                    novoEstado["freightPricing"] = { ...grupoDesligado };
                    novoEstado["freightDriver"] = { ...grupoDesligado };
                    novoEstado["freightFreight"] = { ...grupoDesligado };
                    novoEstado["freightCannotRelease"] = { ...grupoDesligado };
                    novoEstado["freightCancel"] = { ...grupoDesligado };
                    novoEstado["freightReopen"] = { ...grupoDesligado };
                    novoEstado["freightStoppingPointLatLong"] = { ...grupoDesligado };
                }
            }

            const todosOsGruposMarcados = calcularSelecionarTodosGeralCoerente(novoEstado);
            setSelecionarTodosGeral(todosOsGruposMarcados);

            return novoEstado;
        });
    };

    // handler geral
    const handleSelecionarTodosGeral = () => {
        setPermissoes((prev) => {
            const novoValor = !calcularSelecionarTodosGeralCoerente(prev);
            const novoEstado = {};

            for (const grupo in prev) {
                novoEstado[grupo] = {
                    selecionarTodos: novoValor,
                    isView: novoValor,
                    isCreate: novoValor,
                    isEdit: novoValor,
                    isDelete: novoValor,
                };
            }

            setSelecionarTodosGeral(novoValor);

            return novoEstado;
        });
    };

    const onFinish = async (values) => {
        setLoading(true);
        const permissoesLimpidas = { ...permissoes };
        if (permissoesLimpidas["freight"] && permissoesLimpidas["freight"].isView === false) {
            const zerado = { selecionarTodos: false, isView: false, isCreate: false, isEdit: false, isDelete: false };
            permissoesLimpidas["freightPricing"] = { ...zerado };
            permissoesLimpidas["freightDriver"] = { ...zerado };
            permissoesLimpidas["freightFreight"] = { ...zerado };
            permissoesLimpidas["freightCannotRelease"] = { ...zerado };
            permissoesLimpidas["freightCancel"] = { ...zerado };
            permissoesLimpidas["freightReopen"] = { ...zerado };
            permissoesLimpidas["freightStoppingPointLatLong"] = { ...zerado };
        }
        try {

            if (record) {
                perfilService.updatePerfil(record.id, {
                    nomePerfil: values.nomePerfil,
                    permissoes: permissoesLimpidas,
                    selecionarTodosGeral:
                        calcularSelecionarTodosGeralCoerente(permissoesLimpidas),
                    uidShipper: user.uidShipper || "uid não encontrado",
                });
                onSaveChange({ name: values.nomePerfil, message: "Perfil atualizado com sucesso!" });
                onClose();
            }
            else {

                const docRef = await perfilService.savePerfil({
                    nomePerfil: values.nomePerfil,
                    permissoes: permissoesLimpidas,
                    selecionarTodosGeral:
                        calcularSelecionarTodosGeralCoerente(permissoesLimpidas),
                    uidShipper: user.uidShipper || "uid não encontrado",
                });
                onSaveChange({ name: values.nomePerfil, message: "Perfil criado com sucesso!" });
                onClose();
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Modal
                zIndex={1300}
                width={1000}
                className="Modal"
                open={open}
                title={record ? "Editar Perfil" : "Criar Novo Perfil"}
                onCancel={onClose}
                onOk={handleOk}
                confirmLoading={loading}
                okText="Salvar"
                cancelText="Cancelar"
                destroyOnClose={true}
                afterClose={() => {
                    form.resetFields();
                    setPermissoes(initialPermissoes);
                    setSelecionarTodosGeral(true);
                }}
            >
                <Form className="Form" form={form} layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        className="Form"
                        name="nomePerfil"
                        label="Nome do Perfil"
                        rules={[{ required: true, message: "Informe o nome do perfil" }]}
                    >
                        <Input placeholder="Digite o nome do perfil" />
                    </Form.Item>

                    <Form.Item className="Form" label="Permissões" name="permissions">
                        <Permission
                            allowedPermissions={allowedPermissions}
                            permissoes={permissoes}
                            handleChange={handleChange}
                            handleSelecionarTodosGeral={handleSelecionarTodosGeral}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
}